export default {
  total: state => state.total,
  items: state => state.items,
  success: state => state.success,
  successServer: state => state.successServer,
  state: _state => _state.cartState,
  referenceQuantity: state => reference => {
    var _state$items$find$qua, _state$items, _state$items$find;
    return (_state$items$find$qua = (_state$items = state.items) === null || _state$items === void 0 ? void 0 : (_state$items$find = _state$items.find(_ref => {
      var {
        productReference
      } = _ref;
      return productReference === reference;
    })) === null || _state$items$find === void 0 ? void 0 : _state$items$find.quantity) !== null && _state$items$find$qua !== void 0 ? _state$items$find$qua : 0;
  }
};